import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';

import NavVerticalGroup from './VerticalNavGroup';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import VerticalAction from './VerticalAction';

const findActivePath = (items, pathname, path = []) => {
  for (const item of items) {
    if (item.url && pathname.includes(item.url)) {
      return [...path, item.id];
    }
    if (item.children) {
      const childPath = findActivePath(item.children, pathname, [
        ...path,
        item.id,
      ]);
      if (childPath) return childPath;
    }
  }
  return null;
};

const VerticalNav = ({ routesConfig }) => {
  const { pathname } = useLocation();
  const [activePath, setActivePath] = useState([]);

  // Find active path when route changes
  useEffect(() => {
    const newActivePath = findActivePath(routesConfig, pathname) || [];
    setActivePath(newActivePath);
  }, [pathname, routesConfig]);

  const handleToggle = (itemId, itemPath) => {
    setActivePath((prev) => {
      // If clicking already active item, close it and its children
      if (prev.includes(itemId)) {
        return prev.slice(0, prev.indexOf(itemId));
      }

      // If clicking in same parent branch
      const commonPath = itemPath.filter((id) => prev.includes(id));
      return [...commonPath, itemId];
    });
  };

  return (
    <List
      sx={{
        position: 'relative',
        padding: 0,
      }}
      component='div'
    >
      {routesConfig?.map((item) => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && <NavVerticalGroup item={item} level={0} />}

          {item.type === 'collapse' && (
            <VerticalCollapse
              key={item.id}
              item={item}
              level={0}
              activePath={activePath}
              currentPath={[item.id]}
              onToggle={handleToggle}
            />
          )}

          {item.type === 'item' && <VerticalItem item={item} level={0} />}
          {item.type === 'action' && <VerticalAction item={item} level={0} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default VerticalNav;
VerticalNav.propTypes = {
  routesConfig: PropTypes.array.isRequired,
};
